import { ChangeDetectorRef } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { UserService } from '@module-user/services/user/user.service';
import { of, Subject } from 'rxjs';
import { delay, finalize, first, map, switchMap, tap } from 'rxjs/operators';

export const validatorUserUniqueEmail = (
  userHttpService: UserService,
  cdr: ChangeDetectorRef,
  excludedEmail?: string | string[],
  loadingProcess$?: Subject<boolean>,
  debounceRequest = false,
  emailBlacklist: string[] = []
): AsyncValidatorFn => {
  return (control: AbstractControl) => {
    if (!control.value) {
      return of(null);
    }

    if (
      typeof excludedEmail === 'string' &&
      (control.value as string)?.toLowerCase() === excludedEmail?.toLowerCase()
    ) {
      return of(null);
    }

    if (
      Array.isArray(excludedEmail) &&
      excludedEmail
        .map((email) => email.toLowerCase())
        .includes((control.value as string)?.toLowerCase())
    ) {
      return of(null);
    }

    if (
      emailBlacklist
        .map((email) => email.toLowerCase())
        .includes((control.value as string)?.toLowerCase())
    ) {
      control.markAllAsTouched();
      cdr.markForCheck();
      return of({ uniqueEmail: true });
    }

    if (debounceRequest) {
      return of(control.value).pipe(
        delay(500),
        tap(() => loadingProcess$?.next(true)),
        switchMap((value) => userHttpService.checkEmail(value)),
        map((exists) => {
          control.markAllAsTouched();
          cdr.markForCheck();
          return exists ? { uniqueEmail: true } : null;
        }),
        finalize(() => loadingProcess$?.next(false))
      );
    }

    loadingProcess$?.next(true);
    return userHttpService
      .checkEmail(control.value)
      .pipe(
        map((exists) => {
          control.markAllAsTouched();
          cdr.markForCheck();
          loadingProcess$?.next(false);
          return exists ? { uniqueEmail: true } : null;
        })
      )
      .pipe(first());
  };
};
